import { Injectable } from "@angular/core";
import { Printer } from "../model/printer";
import { AuthService } from "./auth.service";
import { PrinterService } from "./printer.service";

@Injectable({
  providedIn: "root",
})
export class PrintWebSocketService {
  isClosed = true;
  printer: Printer;
  private socket$: WebSocket;

  constructor(
    private authService: AuthService,
    private printerService: PrinterService,
  ) {}

  initConnection(): void {
    if (this.isClosed) {
      this.printerService
        .getPrinterByUserId(this.authService.getUserId())
        .then((value) => {
          if (value != null) {
            this.start(value);
          }
        });
    }
  }

  start(printer: Printer): void {
    this.printer = printer;

    if (!this.printer.IsSafeConnection) {
      const protocol = "ws://";
      this.socket$ = new WebSocket(protocol + printer.Ip);

      this.socket$.onerror = (event) => {
        console.log("error", event);
      };

      this.socket$.onclose = (event) => {
        this.isClosed = true;
        setTimeout(() => {
          if (this.isClosed) {
            this.start(this.printer);
          }
        }, 5000);
      };

      this.socket$.onopen = (event) => {
        console.log("open", event);
        this.isClosed = false;
      };
    } else {
      this.isClosed = false;
    }
  }

  sendDirectPrint(printType: string, jsonData: string): void {
    let printName = this.printer.DefaultPrint;
    if (printType === "ticket") {
      printName = this.printer.TicketPrint;
    } else if (printType === "order") {
      printName = this.printer.OrderPrint;
    }

    const userId = this.authService.getUserId();
    const enviroment = this.authService.getEnvironment();
    const printServerName = this.printer.Ip;

    const json = JSON.stringify({
      printServerName,
      printName,
      printType,
      enviroment,
      userId,
      jsonData,
    });

    this.printer.IsSafeConnection
      ? this.printerService.sendDirectPrintMessage(json)
      : this.socket$.send(json);
  }

  sendPrint(printType: string, fileBase64: string): void {
    let printName = this.printer.DefaultPrint;
    if (printType === "ticket") {
      printName = this.printer.TicketPrint;
    } else if (printType === "order") {
      printName = this.printer.OrderPrint;
    }
    const userId = this.authService.getUserId();
    const enviroment = this.authService.getEnvironment();
    const printServerName = this.printer.Ip;

    const json = JSON.stringify({
      printServerName,
      printName,
      fileBase64,
      printType,
      enviroment,
      userId,
    });

    this.printer.IsSafeConnection
      ? this.printerService.sendDirectPrintMessage(json)
      : this.socket$.send(json);
  }
}
